import { FC } from 'react'
import PerFlexRow from '../../../../../components/custom_components/FlexRow'
import { Col, Progress } from 'antd'
import PerText from '../../../../../components/custom_components/Text'
import { colorGenerator } from './util'

type GecoProjectRowProps = {
  label: string
  percent: number
  color: number
}

export const GecoProjectRow: FC<GecoProjectRowProps> = ({ label, percent, color }) => {
  return (
    <PerFlexRow direction="row" mb="s">
      <Col span={8}>
        <PerText transform="capitalize" align={'left'} fontSize={'m'}>
          {label}
        </PerText>
      </Col>
      <Col span={16}>
        <Progress strokeWidth={6} strokeColor={colorGenerator(color)} percent={percent} size="small" format={(percent) => percent + ' %'} />
      </Col>
    </PerFlexRow>
  )
}
